mutation EntityEnvironmentalUpdate($input: EntityEnvironmentalUpdateInput!) {
  entityEnvironmentalUpdate(input: $input) {
    clientMutationId
    entityEnvironmental {
      id
      startDate
      endDate
      description
      entityEnvironmentalItems {
        nodes {
          environmentalImpactTypeId
          feet
          gallons
          hours
          kilogram
          kilometers
          kilowattHours
          litres
          meters
          metricTonnes
          miles
          omissionsEquivalent
          pounds
          quantity
          therms
          tons
          yards
          carbonCreditsAmount
        }
      }
    }
  }
}
